import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Periood

  <span style="color:#85c1dc;">**FI:**</span>
  Maksuaika

  <span style="color:#85c1dc;">**RU:**</span>
  Период
*/
/* @__NO_SIDE_EFFECTS__ */
const m1017 = msg(
  mf`Periood`,
  mf`Maksuaika`,
  mf`Период`,
)

export { m1017 as 'w.menu.jm.periood' }